import { useState, useEffect } from 'react';
import './Configuracio.css';
import API_URL from '../config';

function Configuracio() {
  const [tarifaInterna, setTarifaInterna] = useState('');
  const [nomNegoci, setNomNegoci] = useState('');
  const [missatge, setMissatge] = useState('');
  const [error, setError] = useState('');
  const [carregant, setCarregant] = useState(true);

  useEffect(() => {
    carregarConfiguracio();
  }, []);

  const carregarConfiguracio = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      setCarregant(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/gestio/configuracio/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setTarifaInterna(data.tarifa_interna || '');
        setNomNegoci(data.nom_negoci || '');
      } else {
        setError('Error al carregar la configuració');
      }
    } catch (err) {
      console.error('Error carregant configuració:', err);
      setError('Error al carregar la configuració');
    } finally {
      setCarregant(false);
    }
  };

  const guardarConfiguracio = async () => {
    setMissatge('');
    setError('');

    const token = sessionStorage.getItem('token');
    if (!token) {
      setError('No estàs autenticat');
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/gestio/configuracio/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
        },
        body: JSON.stringify({
          tarifa_interna: tarifaInterna,
          nom_negoci: nomNegoci
        })
      });

      if (response.ok) {
        setMissatge('Configuració guardada');
        } else {
        setError('Error al guardar');
        }
    } catch (err) {
        console.error('Error:', err);
    }
  };

  if (carregant) {
    return (
      <div className="seccio-configuracio">
        <p>Carregant configuració...</p>
      </div>
    );
  }

  return (
    <div className="seccio-configuracio">
      <div className="capçalera-seccio">
        <div className="text-llista">
          <h1>Configuració</h1>
          <p>Paràmetres generals de l'aplicació</p>
        </div>
      </div>

      {missatge && <div className="missatge-exit">{missatge}</div>}
      {error && <div className="missatge-error">{error}</div>}

      {/* Tarifa interna */}
      <div className="bloc-configuracio">
        <h2>Tarifa interna</h2>
        <p className="descripcio">Aquest preu s'usa per calcular els costos al mòdul de rendibilitat</p>
        
        <div className="camp">
          <label>Preu per hora:</label>
          <input
            type="number"
            value={tarifaInterna}
            onChange={(e) => setTarifaInterna(e.target.value)}
            placeholder="20 €/h"
            step="0.01"
            min="0"
          />
        </div>
      </div>

      {/* Dades del negoci de moment nom de negoci */}
      <div className="bloc-configuracio">
        <h2>Dades del negoci</h2>
        <p className="descripcio">Informació que apareixerà en documents i factures</p>
        
        <div className="camp">
          <label>Nom del negoci:</label>
          <input
            type="text"
            value={nomNegoci}
            onChange={(e) => setNomNegoci(e.target.value)}
            placeholder="Fit Training"
            maxLength="100"
          />
        </div>
      </div>

      {/* Botó de guardar la config */}
      <button onClick={guardarConfiguracio} className="boto-guardar">
        Guardar configuració
      </button>
    </div>
  );

}

export default Configuracio;
